import { createRecipe } from './runtime.js';

const checkboxGroupConfig = {"name":"checkboxGroup","defaultVariants":{"orientation":"vertical"},"variantMap":{"orientation":["horizontal","vertical"]}}

export const checkboxGroup = /* @__PURE__ */ createRecipe(checkboxGroupConfig)